<script setup lang="ts">
const route = useRoute()

const isCartLayout = computed(() => route.meta.layout === 'cart')
const isCheckoutLayout = computed(() => route.meta.layout === 'checkout')
</script>

<template>
  <!-- for some reason, on apofinder landing page alertes are cut, overflow-visible is a hotfix -->
  <AlertCoupon
    border="unset"
    class="!of-visible"
  />
  <AlertUnverifiedUser
    v-if="!isCartLayout && !isCheckoutLayout"
    class="!of-visible"
  />
</template>

<style scoped>

</style>
